import { all_information } from '../App';
import { GetKanbanColor } from '../services/CloudScheduler/CloudSchedulerServices';

export const getPriority = async () => {
  let theData: Array<any> = [];
  await GetKanbanColor(all_information.company_id?.toString()).then((el) => {
    theData = el.data;
  });
  return theData;
};
